export default __webpack_public_path__ + "c8315ff65b34aad2916da9624afdb83b.svg";